import { render } from "./TheCartWidget.vue?vue&type=template&id=1070eef0"
import script from "./TheCartWidget.vue?vue&type=script&lang=js"
export * from "./TheCartWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__